module.exports = __webpack_public_path__ + "static/img/frackIcon1.46795a7e.png";